import { InviteStatus, PlaydateInvite, ResponseType } from "../../gql/types";
import { TagVariant } from "./InfoTag";

// Computes tags based on current viewer's response
export const recipientResponseTagComputer = (invite: PlaydateInvite): Array<{ label: string; variant: TagVariant }> => {
    const tags: Array<{ label: string; variant: TagVariant }> = [];

    const viewerResponse = invite.viewerResponse;

    if (!viewerResponse) {
        return tags;
    }

    switch (viewerResponse.responseType) {
        case ResponseType.Accept:
            if (invite.status === InviteStatus.Confirmed) {
                tags.push({
                    label: "Attending",
                    variant: TagVariant.STATE_REPRESENTATION,
                });
            } else {
                tags.push({
                    label: "Availability Shared",
                    variant: TagVariant.STATE_REPRESENTATION,
                });
            }
            break;
        case ResponseType.Reject:
            tags.push({
                label: "Can't Make It",
                variant: TagVariant.REJECTED,
            });
            break;
        case ResponseType.Maybe:
        case ResponseType.NoResponse:
            tags.push({
                label: "Provide Your Availability",
                variant: TagVariant.ACTION_NEEDED,
            });
            break;
    }

    return tags;
};
